// extracted by mini-css-extract-plugin
export default {"wrapper":"PackModalContent_wrapper__j-afT","price":"PackModalContent_price__hIBsi","navi":"PackModalContent_navi__2BToW","toprow":"PackModalContent_toprow__fsGM9"};